import React, {Component} from "react";
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Select from 'react-select';

const styles = {
    singleValue: (base, state) => ({
      ...base,
      color: state.selectProps.menuIsOpen ? '#C0C0C0' : base.color,
    }),
}

class MinistryContactInputForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            ministries: props.ministries,
            contact: props.contact,
        }

    }


    componentDidMount() {
        this.getDropdownList();
    }


    handleMinistryChange = (desig) =>{

        var {contact} = this.state;
        contact.MinistryID = desig.value;
        this.setState({contact: contact});

    }


    handleStartDateChange = (date) => {

        date = moment(date).format('YYYY-MM-DD');
        const {contact} = this.state;
        contact.StartDate = date;
        this.setState({contact: contact})


    }


    handleEndDateChange = (date) => {

        date = moment(date).format('YYYY-MM-DD');
        const {contact} = this.state;
        contact['EndDate'] = date;
        this.setState({contact: contact})

    }


    getDropdownList = _ => {
        const {ministries} = this.state;
        var desigs = [];

        for (var desigId of Object.keys(ministries)) {
            var desig = {
                value: desigId,
                label: ministries[desigId]
            }
            desigs.push(desig)

        }

        desigs.sort((a, b) => (a.label > b.label) ? 1 : -1);

        return this.setState({desigDropDown: desigs});

    }



    render = _ => {

        const {desigDropDown} = this.state;
        const {contact} = this.state;
        const {ministries} = this.state;

        var defaultMinistryValue = {
            label: ministries[contact.MinistryID],
            value: contact.MinistryID
        }


        let content = (
            <form className="form-horizontal">
            <fieldset>
              <div className = "form-group">
                  <label className = "col-lg-3 control-lebel"> Ministry* </label>
                  <div className="col-lg-9">
                  <Select className='react-select-container' 
                    options={desigDropDown} 
                    styles={styles} 
                    isSearchable="true" 
                    isClearable="true" 
                    placeholder="TYPE TO SEARCH FOR MINISTRY" 
                    onChange={this.handleMinistryChange}
                    defaultValue={defaultMinistryValue}
                  />
                  </div>
             </div>
  
              <div className = "form-group">
                  <label className = "col-lg-3 control-lebel">Name (Payee)* 
                  <span>(_ . / \ ' - are allowed)</span>
                  </label>
                  <div className="col-lg-9">
                  <input className="form-control" type="text"  value={contact.Name} onChange={e=> this.setState({ contact:{...contact, Name: e.target.value}})}/>
                  </div>
              </div>

              <div className = "form-group">
                  <label className = "col-lg-3 control-lebel">Primary Email*</label>
                  <div className="col-lg-9">
                  <input className="form-control" type="text"  value={contact.Email1} onChange={e=> this.setState({ contact:{...contact, Email1: e.target.value}})}/>
                  </div>
              </div>

              <div className = "form-group">
                  <label className = "col-lg-3 control-lebel">Secondary Email</label>
                  <div className="col-lg-9">
                  <input className="form-control" type="text"  value={contact.Email2} onChange={e=> this.setState({ contact:{...contact, Email2: e.target.value}})}/>
                  </div>
              </div>

              <div className = "form-group">
                  <label className = "col-lg-3 control-lebel">Tertiary Email</label>
                  <div className="col-lg-9">
                  <input className="form-control" type="text"  value={contact.Email3} onChange={e=> this.setState({ contact:{...contact, Email3: e.target.value}})}/>
                  </div>
              </div>

              <div className = "form-group">
                <label className = "col-lg-3 control-lebel"> Join Date*</label>
                <div className="col-lg-9">
                <div className="date">
                <DatePicker
                    selected={(contact.StartDate === '') ? new Date() : new Date(contact.StartDate)}
                    onChange={this.handleStartDateChange}
                    dateFormat='dd-MM-yyyy'
                />
                </div>
                </div>
            </div>

            <div className = "form-group">
                <label className = "col-lg-3 control-lebel">Leave Date</label>
                <div className="col-lg-9">
                <div className="date">
                <DatePicker
                    selected={(contact.EndDate === '') ? null : new Date(contact.EndDate)}
                    onChange={this.handleEndDateChange}
                    dateFormat='dd-MM-yyyy'
                />
                {/* <span className="error">{this.state.errors["endDate"]}</span> */}
                </div>
                </div>
            </div>

            <div className = "form-group">
                <div className="col-lg-12 col-lg-offset-9">
                <button type="button" className="btn btn-primary submit" onClick={() => this.props.handleSave(this.state.contact)} disabled={this.state.isButtonDisabled}>Save</button>
                </div>
            </div>

            </fieldset>
          </form>
        )

        return content
    }

    


}


export default MinistryContactInputForm;
